import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Login from "./Login";
import Register from "./Register";
import ResetPassword from "./ResetPassword";
import VerifyEmail from "./VerifyEmail";
import { useLocation, useNavigate } from "react-router-dom";
import { CenteredModal } from "components/common/modals";
import { isVerified, verifyEmail } from "actions/auth";
import {
  showLogin,
  showRegister,
  hideModal,
  setShowModal,
  setShowResetPassword,
  setShowVerifyEmail,
} from "actions/ui_control";
const Authentication = () => {
  // const [showResetPassword, setShowResetPassword] = useState(false);
  // const [showVerifyEmail, setShowVerifyEmail] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  // Params
  const isVerifyEmail = params.get("verify-email");
  const token = params.get("token");
  const uid = params.get("uid");

  const { isLoggedIn } = useSelector(state => state.auth);
  const { showModal, isMember, showResetPassword, showVerifyEmail } =
    useSelector(state => state.ui_control);

  // Check the for reset password path

  useEffect(() => {
    if (isVerifyEmail && isVerifyEmail === "true" && token) {
      dispatch(verifyEmail(token))
        .then(res => {
          console.log({ res });

          // const emailVerifiedState = dispatch(isVerified());
          // const emailVerified =
          //   emailVerifiedState && emailVerifiedState.is_verified;
          const emailVerified = res && res.is_verified;
          dispatch(setShowVerifyEmail());
          setIsEmailVerified(emailVerified);
          // if (!emailVerified) setShowVerifyEmail(true);
          // else onHide();
        })
        .catch(error => {
          console.log({ error });
        });
    } else if (token && uid) {
      // dispatch(setShowModal());
      // setShowResetPassword(true);
      dispatch(setShowResetPassword());
    }
    // to watch for changes in query parameters
  }, [location.search]);
  // Check if the user is logged in
  // useEffect(() => {
  //   if (isLoggedIn)
  //     dispatch(verifyEmail()).then(() => {
  //       const emailVerifiedState = dispatch(isVerified());
  //       const emailVerified =
  //         emailVerifiedState && emailVerifiedState.is_verified;
  //       setIsEmailVerified(emailVerified);
  //       if (!emailVerified) setShowVerifyEmail(true);
  //       else onHide();
  //     });
  // }, [isLoggedIn, dispatch]);
  useEffect(() => {
    if (isLoggedIn && isEmailVerified) onHide();
  }, [showModal]);

  const displayLogin = () => {
    dispatch(showLogin());
  };
  const displayRegister = () => {
    dispatch(showRegister());
  };
  const onHide = () => {
    dispatch(hideModal());
    // setShowResetPassword(false);
  };
  const content = (
    <>
      {!isLoggedIn && !showVerifyEmail && (
        <>
          {showResetPassword ? (
            <ResetPassword
              show={showResetPassword}
              paramsToken={token}
              paramsUID={uid}
              // onLoginCallback={onLoginCallback}
            />
          ) : isMember ? (
            <Login />
          ) : (
            <Register />
          )}
        </>
      )}
      {showVerifyEmail && (
        <VerifyEmail
          isEmailVerified={isEmailVerified}
          show={showVerifyEmail}
          setIsEmailVerified={setIsEmailVerified}
        />
      )}
    </>
  );

  return (
    <CenteredModal
      bodyContent={content}
      show={showModal}
      size={"md"}
      setShow={onHide}
    />
  );
};
export default Authentication;
